import React, { useEffect, useImperativeHandle } from 'react'
import { connect } from 'react-redux'
import IFModal from 'Components/IFModal/IFModal'
import IFText from 'Components/IFText/IFText'
import Styles from './AddChargePointModal.module.css'
import IFButton from 'Components/IFButton/IFButton'
import { Colors } from 'Theme'
import IFTextInput from 'Components/IFTextInput/IFTextInput'
import { useTranslation } from 'react-i18next'
import StationSelectors from 'Stores/Station/Selectors'
import ChargePointSelectors from 'Stores/ChargePoint/Selectors'
import ChargePointActions from 'Stores/ChargePoint/Actions'
import RequestState from 'Enums/RequestState'

const AddChargePointModal = React.forwardRef(
  ({ addChargePointRequestState, addChargePoint, station }, ref) => {
    const [stationID, setStationID] = React.useState('')
    const [stationName, setStationName] = React.useState('')
    const [stationIdError, setStationIdError] = React.useState('')
    const [stationNameError, setStationNameError] = React.useState('')
    const { t } = useTranslation()

    const handleCloseIcon = () => {
      setStationID('')
      setStationName('')
      setStationIdError('')
      setStationNameError('')
    }
    const customDialogContentStyle = {
      width: '40rem',
    }
    useEffect(() => {
      if (addChargePointRequestState === RequestState.SUCCEEDED) {
        handleCloseIcon()
      }
    }, [addChargePointRequestState])
    return (
      <IFModal
        onDismiss={handleCloseIcon}
        maxWidth={'40rem'}
        title={t('AddChargePointModal.Title')}
        ref={ref}
        dialogContentStyle={customDialogContentStyle}
      >
        <div className={Styles.Container}>
          <div>
            <div className={Styles.TextField}>
              <IFText className={Styles.Text}>
                {t('AddChargePointModal.StationIDText')}
              </IFText>

              <IFTextInput
                isFixed={false}
                value={stationID}
                className={Styles.TextInput}
                fontSize={14}
                onChange={(e) => {
                  setStationID(e.target.value)
                  if (stationIdError.length > 0) {
                    e.target.value.length === 0
                      ? setStationIdError(t('AddChargePointModal.Required'))
                      : setStationIdError('')
                  }
                }}
                onBlur={(e) => {
                  e.target.value.length === 0
                    ? setStationIdError(t('AddChargePointModal.Required'))
                    : setStationIdError('')
                }}
                {...(stationIdError.length > 0
                  ? { errorText: stationIdError }
                  : {})}
              />
            </div>

            <IFText className={Styles.Text}>
              {t('AddChargePointModal.StationNameText')}
            </IFText>
            <IFTextInput
              value={stationName}
              className={Styles.TextInput}
              onChange={(e) => {
                setStationName(e.target.value)
                if (stationNameError.length > 0) {
                  e.target.value.length === 0
                    ? setStationNameError(t('AddChargePointModal.Required'))
                    : setStationNameError('')
                }
              }}
              onBlur={(e) => {
                e.target.value.length === 0
                  ? setStationNameError(t('AddChargePointModal.Required'))
                  : setStationNameError('')
              }}
              {...(stationNameError.length > 0
                ? { errorText: stationNameError }
                : {})}
            />
          </div>

          <div className={Styles.Button}>
            <IFButton
              text={t('AddChargePointModal.ButtonText')}
              color={Colors.primary}
              isFill={true}
              size={'sm'}
              isDead={stationID === '' || stationName === ''}
              isLoading={addChargePointRequestState === RequestState.LOADING}
              onClick={() => {
                addChargePoint({
                  huid: stationID,
                  name: stationName,
                  station: station._id,
                })
              }}
            ></IFButton>
          </div>
        </div>
      </IFModal>
    )
  },
)

function mapDispatchToProps(dispatch) {
  return {
    addChargePoint: (chargePoint) =>
      dispatch(ChargePointActions.addChargePoint(chargePoint)),
  }
}

const mapStateToProps = (state) => ({
  addChargePointRequestState:
    ChargePointSelectors.getAddChargePointRequestState(state),
  station: StationSelectors.getSelectedStation(state),
})

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(AddChargePointModal)
